<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="lock">
            <defs>
                <path v-if="width == 48" id="q5fligw1ya" d="M34.295 21.237h-20.59c-2.335 0-4.234 1.9-4.234 4.234v10.295C9.47 38.1 11.37 40 13.705 40h20.59c2.335 0 4.234-1.9 4.234-4.234V25.47c0-2.335-1.9-4.234-4.234-4.234zm1.649 14.529c0 .91-.74 1.649-1.649 1.649h-20.59c-.91 0-1.649-.74-1.649-1.65V25.472c0-.91.74-1.65 1.649-1.65h20.59c.91 0 1.649.74 1.649 1.65v10.295zM24 8c-4.768 0-8.646 3.879-8.646 8.646v5.883c0 .714.578 1.293 1.292 1.293.714 0 1.293-.579 1.293-1.293v-5.883c0-3.342 2.719-6.06 6.061-6.06s6.061 2.718 6.061 6.06v5.883c0 .714.579 1.293 1.293 1.293s1.292-.579 1.292-1.293v-5.883C32.646 11.88 28.768 8 24 8z"/>
                <path v-else-if="width == 18" id="j285r2xbla" d="M12.86 7.965H5.14c-.875 0-1.587.712-1.587 1.588v3.86c0 .875.712 1.587 1.587 1.587h7.72c.875 0 1.587-.712 1.587-1.588v-3.86c0-.875-.712-1.587-1.587-1.587zm.618 5.447c0 .341-.278.619-.618.619H5.14c-.34 0-.618-.278-.618-.619v-3.86c0-.34.278-.617.618-.617h7.72c.34 0 .618.277.618.618v3.86zm-1.301-7.815c-.149-.732-.549-1.394-1.127-1.866C10.473 3.259 9.745 3 9 3h-.003c-.866 0-1.68.339-2.292.952-.611.613-.948 1.427-.947 2.292V8.45c0 .268.217.485.485.485s.485-.217.485-.485V6.244c0-.607.235-1.178.664-1.607.428-.43.999-.667 1.606-.668H9c1.076 0 2.013.766 2.227 1.82.053.263.309.433.571.38.263-.054.432-.31.379-.572z"/>
                <path v-else id="fv1jpmxe0a" d="M17.148 10.618H6.852c-1.167 0-2.117.95-2.117 2.117v5.148c0 1.167.95 2.117 2.117 2.117h10.296c1.167 0 2.117-.95 2.117-2.117v-5.148c0-1.167-.95-2.117-2.117-2.117zm.824 7.265c0 .455-.37.824-.824.824H6.852c-.454 0-.824-.37-.824-.824v-5.148c0-.454.37-.824.824-.824h10.296c.454 0 .824.37.824.824v5.148zM12 4C9.616 4 7.677 5.94 7.677 8.323v2.942c0 .357.29.646.646.646.357 0 .646-.29.646-.646V8.323c0-1.67 1.36-3.03 3.031-3.03s3.03 1.36 3.03 3.03v2.942c0 .357.29.646.647.646.357 0 .646-.29.646-.646V8.323C16.323 5.94 14.383 4 12 4z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask :id="`${id}p418bmawrb`" fill="#fff">
                    <use v-if="width == 48" xlink:href="#q5fligw1ya"/>
                    <use v-else-if="width == 18" xlink:href="#j285r2xbla"/>
                    <use v-else xlink:href="#fv1jpmxe0a"/>
                </mask>
                <g class="path" :fill="fill" :mask="`url(#${id}p418bmawrb)`">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-lock',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        id: {
            type: Number,
            default: 1
        },
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>